export const CONDITION_INCLUDE = 'include';
export const CONDITION_EXCLUDE = 'exclude';

export const CONDITION_SOURCE: Array<{ value: string; labelKey: string }> = [
  { value: CONDITION_INCLUDE, labelKey: 'DisplayTimingGroup.include' },
  { value: CONDITION_EXCLUDE, labelKey: 'DisplayTimingGroup.exclude' },
];

export const GIVEN_TIME_TYPE_NONE = 'none';
export const GIVEN_TIME_TYPE_LUNCH = 'lunch';
export const GIVEN_TIME_TYPE_RANGE = 'range';
export const GIVEN_EXTEND_TIME_DEFAULT = parseInt(process.env.REACT_APP_DISPLAY_TIMING_EXTEND_TIME_DEFAULT || '10', 10);
export const GIVEN_EXTEND_TIME_OPTIONS = (process.env.REACT_APP_DISPLAY_TIMING_TIME_OPTIONS || '0,5,10,15,20,30')
  .split(',')
  .map((value) => parseInt(value.trim(), 10))
  .filter((value) => !isNaN(value));

export const WEEKDAY_MASK_DEFAULT = 255; // 11111111 (All days)
export const WEEKDAY_LABELS: Array<[number, string]> = [
  [128, '月'],
  [64, '火'],
  [32, '水'],
  [16, '木'],
  [8, '金'],
  [4, '土'],
  [2, '日'],
  [1, '祝'],
];

export const MONTHLY_DAY_OPTIONS: Array<{ key: string; value: number }> = Array.from({ length: 31 }, (_, i) => ({
  key: `${i + 1}`,
  value: i + 1,
}));
